import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {handleChange} from 'utils/ComponentUtilFunctions';
import classNames from 'classnames';
import {authenticate as authenticateApi, logOperatorSession} from 'services/user/api';
import {getCookie} from "../../utils/CookieManager";
import config from "../../config";
import {Link} from "react-router-dom";
import BlueButton from "../../components-new/buttons/BlueButton";
import {getUserInfoFromToken} from "../../services/user/reducer";
import Input from "../../components-new/form/Input";
import SilverButton from "../../components-new/buttons/SilverButton";
import LockIcon from '../../assets/icons/LockIcon';
import PermIdentityIcon from '../../assets/icons/PermIdentityIcon';

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            password: '',
            disabled: false,
            error: null,
        };

        this.handleChange = handleChange.bind(this);
    }

    handleSubmit = async (event) => {
        event.preventDefault();
        const {disabled, username, password} = this.state;
        const {authenticate} = this.props;
        if (disabled) {
            return false;
        }
        this.setState({disabled: true});
        try {
            await authenticateApi(username, password);
            const token = getCookie(config.jwtAuthToken);

            const userInfo = getUserInfoFromToken(token);
            try {
                await logOperatorSession({
                    operatorPlatformId: userInfo.id,
                    parentCompanyId: userInfo.companyId,
                    actionType: 'LOGIN',
                    userAgent: navigator.userAgent,
                });
            } catch (e) {
                console.error("Logging login failed", e);
            }

            authenticate(token);

        } catch (err) {
            this.setState({
                error: err,
            });
        } finally {
            this.setState({
                disabled: false,
            });
        }
        return false;
    };

    render() {
        const {
            username, password, error
        } = this.state;
        return (
            <div>

                <h1 className="form-header">
                    Sign-in
                </h1>

                <div className="app-login-form">
                    <form onSubmit={this.handleSubmit} className="auth-form">

                        <Input
                            type="text"
                            label="Email or username"
                            leadingIcon={<PermIdentityIcon width={20} height={20}/>}
                            className={classNames('', {error})}
                            value={username}
                            autoComplete={'on'}
                            name={'username'}
                            onChange={this.handleChange('username')}
                            placeholder={'Email or username'}
                        />

                        <Input
                            type="password"
                            label="Password"
                            leadingIcon={<LockIcon width={20} height={20}/>}
                            className={classNames('', {error})}
                            onChange={this.handleChange('password')}
                            name={'password'}
                            value={password}
                            placeholder={'Password'}
                        />

                        <p style={{marginBottom: '20px'}}
                           className={classNames('form-element-label', 'hide-on-error', {error})}>
                            {/* A request that never reached the server - offline,
                                blocked, timed out - rejects with no response at
                                all, and reading .status off it threw right here,
                                so a dropped connection blanked the sign-in page
                                instead of saying anything. */}
                            {error && !error.response &&
                                'Could not reach the server, please try again'
                            }
                            {error && error.response && error.response.status === 401 &&
                                'Invalid username or password'
                            }
                            {error && error.response && error.response.status === 429 &&
                                'Too many login attempts, please try again later'
                            }
                        </p>

                        <BlueButton className="auth-submit-button" height={36} type={'submit'} children={'Sign-In'}/>

                        <div className="auth-form-link">
                            <Link to="/forgot" className="auth-form-link-button">
                                <SilverButton asDiv variant="ghost" height={36}>
                                    Password recovery
                                </SilverButton>
                            </Link>
                        </div>

                    </form>
                </div>
            </div>
        );
    }
}

Login.propTypes = {
    authenticate: PropTypes.func,
};


export default Login;



// WEBPACK FOOTER //
// ./src/scenes/auth/Login.jsx